import dayjs from 'dayjs'

const twoDigitFullDate = function(dateStr) {
	if(!dateStr) return '---'
	return dayjs(dateStr).format('MM/DD/YY')
}

const twoDigitMonthDay = function(dateStr) {
	if(!dateStr) return '---'
	return dayjs(dateStr).format('MM/DD')
}

const relativeDateCompact = function(dateStr) {
	if(!dateStr) return '---'
	
	var dateOld = dayjs(dateStr)
	var dateNew = dayjs()
	var diff = Math.ceil(dateNew.diff(dateOld) / 1000)
	
	if (diff < 60) {
		// Under a minute
		return diff + 's'
	} else if (diff < 60 * 60) {	
		// Under an hour
		return Math.ceil(diff / 60) + 'm'
	} else if (diff < 60 * 60 * 24) {	
		// Under a day
		return Math.ceil(diff / (60 * 60)) + 'h'
	} else if (diff < 60 * 60 * 24 * 30) {	
		// Under a month
		return Math.ceil(diff / (60 * 60 * 24)) + 'd'
	} else if (diff < 60 * 60 * 24 * 365) {	
		// Under a year
		return Math.ceil(diff / (60 * 60 * 24 * 30)) + 'mo'
	} else {
		return Math.ceil(diff / (60 * 60 * 24 * 365)) + 'y'
	}
}

const hourMinute = function(dateStr) {
	if(!dateStr) return '---'

	return dayjs(dateStr).format('h:mma')
}

export {
	twoDigitFullDate,
	twoDigitMonthDay,
	relativeDateCompact,
	hourMinute
}
